import { PsChartStore } from 'components/ps-chart/PsChartStore'
import { Slice } from 'components/ps-chart/models/Slice'
import { Thread } from 'components/ps-chart/models/Thread'

export const moveToSlice = (
  sliceId: number,
  psChartStore: PsChartStore,
  verticalShift?: number,
) => {
  const { hState, vState } = psChartStore

  const move = { x: hState.xStart, y: vState.yStart }

  const slice = psChartStore.sliceById.get(sliceId)
  if (slice == null) {
    throw new Error(`The slice: ${sliceId} was not found!`)
  }

  const isPinned = psChartStore.traceAnalyzeStore.pinnedIdsSet.has(slice.threadId)
  const yPx = getSliceY(slice, psChartStore)

  const isYScrollable = psChartStore.vState.mainTotalHeight > psChartStore.vState.scrollableHeight

  if (!isPinned && isYScrollable) {
    const { headerHeight } = psChartStore.chartSettings.renderEngine
    const maxScrollY = psChartStore.vState.mainTotalHeight - psChartStore.vState.scrollableHeight
    const shiftY =
      verticalShift ?? headerHeight + Math.floor(psChartStore.vState.scrollableHeight / 2)

    move.y = yPx - shiftY
    move.y = Math.min(Math.max(move.y, 0), maxScrollY)
  }

  const isXScrollable = psChartStore.hState.zoom > 1
  if (isXScrollable) {
    const visibleWidthTime = psChartStore.hState.width * psChartStore.hState.timePerPx
    const maxScrollTime = psChartStore.hState.xWidthTotal - visibleWidthTime

    const sliceWidthTime = slice.end - slice.start
    move.x = slice.start + sliceWidthTime / 2 - visibleWidthTime / 2
    move.x = Math.min(Math.max(move.x, 0), maxScrollTime)
  }

  psChartStore.moveTo(move.x, move.y)
}

export const moveToThread = (
  thread: Thread,
  psChartStore: PsChartStore,
  verticalShift?: number,
) => {
  const { hState, vState } = psChartStore

  const move = { x: hState.xStart, y: vState.yStart }

  const isPinned = psChartStore.traceAnalyzeStore.pinnedIdsSet.has(thread.id)
  const yPx = psChartStore.getThreadY(thread.id)

  const isYScrollable = psChartStore.vState.mainTotalHeight > psChartStore.vState.scrollableHeight

  if (!isPinned && isYScrollable) {
    const { headerHeight } = psChartStore.chartSettings.renderEngine
    const maxScrollY = psChartStore.vState.mainTotalHeight - psChartStore.vState.scrollableHeight
    const shiftY =
      verticalShift ?? headerHeight + Math.floor(psChartStore.vState.scrollableHeight / 2)

    move.y = yPx - shiftY
    move.y = Math.min(Math.max(move.y, 0), maxScrollY)
  }
  psChartStore.moveTo(move.x, move.y)
}

const getSliceY = (slice: Slice, psChartStore: PsChartStore): number => {
  const { blockHeight } = psChartStore.chartSettings.renderEngine.threads

  return psChartStore.getThreadY(slice.threadId) + blockHeight * slice.level
}
